// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-confirmation-modal {
  /* Glassmorphism effect */
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 1rem;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.delete-confirmation-modal h2 {
  color: var(--color-danger);
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.delete-warning {
  color: var(--color-text-secondary);
  margin-bottom: 1rem;
  line-height: 1.5;
}

.delete-items-list {
  background: rgba(255, 59, 48, 0.1);
  border-left: 3px solid var(--color-danger);
  padding: 1rem 1rem 1rem 2rem;
  margin: 1.5rem 0;
  border-radius: 0.5rem;
}

.delete-items-list li {
  color: var(--color-text-primary);
  margin: 0.5rem 0;
  font-size: 0.95rem;
}

.delete-confirmation-modal .modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.delete-confirmation-modal .btn-cancel {
  background: var(--color-secondary);
  color: var(--color-text-primary);
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s;
}

.delete-confirmation-modal .btn-cancel:hover {
  background: var(--color-secondary-hover);
  transform: translateY(-2px);
}

.delete-confirmation-modal .btn-delete {
  background: var(--color-danger);
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s;
  font-weight: 600;
}

.delete-confirmation-modal .btn-delete:hover {
  background: #d32f2f;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 59, 48, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/DeleteConfirmationModal.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C","sourcesContent":[".delete-confirmation-modal {\n  /* Glassmorphism effect */\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 1rem;\n  padding: 2rem;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.delete-confirmation-modal h2 {\n  color: var(--color-danger);\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n}\n\n.delete-warning {\n  color: var(--color-text-secondary);\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.delete-items-list {\n  background: rgba(255, 59, 48, 0.1);\n  border-left: 3px solid var(--color-danger);\n  padding: 1rem 1rem 1rem 2rem;\n  margin: 1.5rem 0;\n  border-radius: 0.5rem;\n}\n\n.delete-items-list li {\n  color: var(--color-text-primary);\n  margin: 0.5rem 0;\n  font-size: 0.95rem;\n}\n\n.delete-confirmation-modal .modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n}\n\n.delete-confirmation-modal .btn-cancel {\n  background: var(--color-secondary);\n  color: var(--color-text-primary);\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.2s;\n}\n\n.delete-confirmation-modal .btn-cancel:hover {\n  background: var(--color-secondary-hover);\n  transform: translateY(-2px);\n}\n\n.delete-confirmation-modal .btn-delete {\n  background: var(--color-danger);\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.2s;\n  font-weight: 600;\n}\n\n.delete-confirmation-modal .btn-delete:hover {\n  background: #d32f2f;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 59, 48, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
